// Components/Pages/Admin/api.js
const API_BASE = 'https://api.rigokenya.org';

export const api = {
  // Auth
  login: async (username, password) => {
    const response = await fetch(`${API_BASE}/api/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
      credentials: 'include'
    });
    return response.json();
  },
  
  logout: async () => {
    const response = await fetch(`${API_BASE}/api/admin/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    return response.json();
  },
  
  getMe: async () => {
    const response = await fetch(`${API_BASE}/api/admin/me`, {
      credentials: 'include'
    });
    return response.json();
  },

  // Thematic Pillars
  getPillars: async () => {
    const response = await fetch(`${API_BASE}/api/pillars`);
    return response.json();
  },
  
  createPillar: async (data) => {
    const response = await fetch(`${API_BASE}/api/pillars`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updatePillar: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/pillars/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deletePillar: async (id) => {
    const response = await fetch(`${API_BASE}/api/pillars/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // Projects
  getProjects: async () => {
    const response = await fetch(`${API_BASE}/api/projects`);
    return response.json();
  },
  
  createProject: async (data) => {
    const response = await fetch(`${API_BASE}/api/projects`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updateProject: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/projects/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deleteProject: async (id) => {
    const response = await fetch(`${API_BASE}/api/projects/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // Stories
  getStories: async () => {
    const response = await fetch(`${API_BASE}/api/stories`);
    return response.json();
  },
  
  createStory: async (data) => {
    const response = await fetch(`${API_BASE}/api/stories`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updateStory: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/stories/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deleteStory: async (id) => {
    const response = await fetch(`${API_BASE}/api/stories/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // Gallery
  getGallery: async () => {
    const response = await fetch(`${API_BASE}/api/gallery`);
    return response.json();
  },
  
  createGalleryImage: async (data) => {
    const response = await fetch(`${API_BASE}/api/gallery`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updateGalleryImage: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/gallery/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deleteGalleryImage: async (id) => {
    const response = await fetch(`${API_BASE}/api/gallery/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // Resources
  getResources: async () => {
    const response = await fetch(`${API_BASE}/api/resources`);
    return response.json();
  },
  
  createResource: async (data) => {
    const response = await fetch(`${API_BASE}/api/resources`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updateResource: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/resources/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deleteResource: async (id) => {
    const response = await fetch(`${API_BASE}/api/resources/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // Media
  getMedia: async () => {
    const response = await fetch(`${API_BASE}/api/media`);
    return response.json();
  },
  
  createMedia: async (data) => {
    const response = await fetch(`${API_BASE}/api/media`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  updateMedia: async (id, data) => {
    const response = await fetch(`${API_BASE}/api/media/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      credentials: 'include'
    });
    return response.json();
  },
  
  deleteMedia: async (id) => {
    const response = await fetch(`${API_BASE}/api/media/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    return response.json();
  },

  // File Upload
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${API_BASE}/api/upload`, {
      method: 'POST',
      body: formData,
      credentials: 'include'
    });
    return response.json();
  }
};